import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'global-ir-satellite-radar-legend-svg',
  templateUrl: './global_ir_satellite_radar_legend.svg',
  styleUrl: '../../../../twc-legend/shared-legend-svg.css',
  standalone: true,
  imports: [CommonModule]
})
export class GlobalIRSatelliteRadarSvgComponent {}
